// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2TnLe","visuallyhidden":"_356Kz","hide-text":"v5v-L","center":"_2l1RP","noprint":"_2uUs0","userMenu":"_1xOWk","userMenuInner":"_2aboC","userMenuButtons":"_1iOJr","loginButton":"BN8bN","subscribeButton":"_3AaMt","loginButtonWrapper":"_3IoB4","subscribeButtonWrapper":"_2SFQH","userDetails":"_2i2iF","userLink":"_250z6","userButtonWrapper":"_3gbRY"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/UserMenu.scss
 ** module id = 457
 ** module chunks = 0
 **/